import React from 'react'
import PropTypes from 'prop-types'
// import TableViewNoticePopover from './notice'
import { observer } from 'mobx-react'
import FontAwesome from 'react-fontawesome'

import { ButtonToolbar, ButtonGroup, Button } from 'react-bootstrap'

import { LIST_VIEW, TABLE_VIEW } from '../../constants'

function ViewButton({ displayMode, onClick, disableTable, disableList }) {
  let title = disableTable
    ? '      Table view only available for single data class (filtered) lists'
    : ''

  return (
    <div>
      <small>View As</small>
      <ButtonToolbar>
        <ButtonGroup>
          <Button
            active={displayMode === LIST_VIEW}
            onClick={() => onClick(LIST_VIEW)}
            disabled={disableList}>
            <FontAwesome name="list" /> List
          </Button>
          <Button
            active={displayMode === TABLE_VIEW}
            onClick={() => onClick(TABLE_VIEW)}
            disabled={disableTable}
            title={title}>
            <FontAwesome name="table" /> Table
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
      {/*<TableViewNoticePopover />*/}
    </div>
  )
}

ViewButton.propTypes = {
  displayMode: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disableTable: PropTypes.bool,
  disableList: PropTypes.bool,
}

ViewButton.defaultProps = {
  disableTable: false,
  disableList: false,
}

export default observer(ViewButton)
